import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=3efed076&scoped=true&"
import script from "./PrizeItem.vue?vue&type=script&lang=js&"
export * from "./PrizeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=3efed076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efed076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efed076')) {
      api.createRecord('3efed076', component.options)
    } else {
      api.reload('3efed076', component.options)
    }
    module.hot.accept("./PrizeItem.vue?vue&type=template&id=3efed076&scoped=true&", function () {
      api.rerender('3efed076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PrizeItem.vue"
export default component.exports